var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgAo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.331h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.331h512v170.663H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#ffda44"
}, /*#__PURE__*/React.createElement("path", {
  d: "M232.598 221.069l14.469 10.5-5.513 17.005 14.456-10.516 14.47 10.499-5.536-16.999 14.458-10.518-17.877.012-5.535-17-5.515 17.006z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M298.666 182.094A84.776 84.776 0 00256 170.69v22.255a62.663 62.663 0 0131.536 8.427c30.119 17.389 40.476 56.039 23.086 86.158-17.388 30.119-56.04 40.476-86.158 23.087a62.657 62.657 0 01-21.08-19.882l-18.584 12.27c7.066 10.739 16.662 20.037 28.533 26.891 40.75 23.526 93.04 9.515 116.567-31.234 23.527-40.75 9.516-93.042-31.234-116.568z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.792 241.154c-5.9 10.786-1.939 24.313 8.846 30.214l72.299 39.506c-4.916 8.988-2.306 19.927 6.682 24.843L314.15 346.4c8.988 4.917 20.261 1.616 25.178-7.372l10.683-19.529-143.219-78.345z"
}))));

export default SvgAo;